// Copyright Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.
import { ProblemDetails } from "./ProblemDetails.js";
const OPERATION_ID_HEADER = "x-requestid";
const API_SERVER_ERROR_HEADER = "x-apiserver-error";
export class ApiException extends Error {
    constructor(message, status, headers, problemDetails) {
        var _a;
        super();
        this.problemDetails = problemDetails != null && problemDetails.status !== undefined ? problemDetails : ProblemDetails.fromJS({
            "title": headers[API_SERVER_ERROR_HEADER] ? decodeURIComponent(headers[API_SERVER_ERROR_HEADER]) : "HTTP status code " + status,
            "status": status,
            "operationId": headers[OPERATION_ID_HEADER],
        });
        this.message = (_a = this.problemDetails.title) !== null && _a !== void 0 ? _a : message;
        this.status = status;
        this.headers = headers;
    }
}
